module.exports = __webpack_public_path__ + "static/media/user.563a8983.svg";